<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="bar">
  <div class="inner" [style.width]="width()"></div>
</div>
